/**
 * Textos (`en`) del tall «evidence» de Qualitat i APPCC (OBR-171). Tall propi: no es toca `en.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const evidenceEn = {
  'backoffice.qualityEvidence': {
    // ── Screen ────────────────────────────────────────────────────────────────────────────
    subtitle:
      'Generate the dossier with the quality records of a period, ready to show at an inspection.',
    periodTitle: 'Period',
    fromLabel: 'From',
    toLabel: 'To',
    periodIssue_from_invalid: 'The start date is not valid.',
    periodIssue_to_invalid: 'The end date is not valid.',
    periodIssue_from_after_to: 'The start date cannot be after the end date.',
    blocksTitle: 'What to include',
    blockHint_homologation:
      'Each supplier with its status, the status changes of the period and its documents (sanitary registry, certificates).',
    blockHint_receptionControls:
      'The lines received on confirmed delivery notes, with temperature, packaging, labelling, decision and who recorded it.',
    blockHint_selfChecks:
      'The self-checks done (who, when and result, with out-of-range values) and the ones that were due and not done.',
    blockHint_nonConformities:
      'The non-conformities opened in the period with their corrective actions and history.',
    blockHint_training:
      'Each food handler with their trainings (topic, date, provider and expiry) and their status.',
    noBlockSelected: 'Tick at least one block to be able to download.',
    downloadPdf: 'Download the PDF',
    downloadExcel: 'Download the Excel',
    preparing: 'Preparing the file…',
    downloadError: 'The file could not be generated: {{message}}',
    brandingError:
      'The obrador identity (name, logo, sanitary registry) could not be read: {{message}}',
    previewTitle: 'Records of the period',
    previewLoading: 'Reading the records…',
    previewUnavailable: 'Could not be read: {{message}}',
    retry: 'Try again',
    footnote:
      'The data is read at the moment of download. This screen is read-only: it does not change any record.',

    // ── Document (PDF and Excel) ──────────────────────────────────────────────────────────
    documentTitle: 'Inspection evidence',
    period: 'Period',
    generatedOn: 'Generated on',
    generatedBy: 'Generated by',
    registry: 'Sanitary registry',
    summaryTitle: 'Summary',
    colBlock: 'Block',
    colIndicator: 'Indicator',
    colValue: 'Value',
    emptyBlock: 'No records in this period.',
    unavailableBlock:
      'This block could not be read when the document was generated. It does not mean there are no records.',
    emptyEvents: 'No status changes in this period.',
    emptyDocuments: 'No documents on file.',
    emptyMissed: 'No self-checks left undone.',
    emptyRecords: 'No self-checks done in this period.',
    emptyActions: 'No corrective actions.',
    emptyNcEvents: 'No events.',
    pageOf: 'Page {{page}} of {{total}}',
    periodRange: '{{from}} – {{to}}',
    valuePhoto: 'photo attached',
    flagOutOfRange: 'out of range',
    flagExpired: 'expired',
    flagExpiredFeminine: 'expired',
    noExpiry: 'No expiry',
    rangeBoth: '{{min}} – {{max}}',
    rangeMin: 'min. {{value}}',
    rangeMax: 'max. {{value}}',

    // Tables
    tableSuppliers: 'Suppliers and approval status',
    tableHomologationEvents: 'Status changes in the period',
    tableDocuments: 'Supplier documents',
    tableReceptionLines: 'Received lines with their check',
    tableRecords: 'Self-checks done',
    tableMissed: 'Self-checks not done',
    tableNonConformities: 'Non-conformities',
    tableActions: 'Corrective actions',
    tableNcEvents: 'Non-conformity history',
    tableTrainings: 'Registered trainings',

    // Columns
    colSupplier: 'Supplier',
    colCode: 'Code',
    colStatus: 'Status',
    colStatusAt: 'Date and time',
    colResponsible: 'Responsible',
    colNotes: 'Notes',
    colChangedAt: 'Date and time',
    colFrom: 'From',
    colTo: 'To',
    colReason: 'Reason',
    colBy: 'Done by',
    colDocType: 'Type',
    colDocName: 'Document',
    colDocNumber: 'Number',
    colIssuedOn: 'Issued',
    colExpiresOn: 'Expiry',
    colReceptionDate: 'Date',
    colReceptionNumber: 'Delivery note',
    colArticle: 'Article',
    colInternalLot: 'Internal lot',
    colSupplierLot: 'Supplier lot',
    colQuantity: 'Quantity',
    colUnit: 'Unit',
    colTemperature: 'Temp. (ºC)',
    colRange: 'Range (ºC)',
    colTemperatureCheck: 'Temperature check',
    colPackaging: 'Packaging',
    colLabeling: 'Labelling',
    colOutcome: 'Outcome',
    colRecordedBy: 'Recorded by',
    colRecordedAt: 'Check date and time',
    colTemplate: 'Self-check',
    colFrequency: 'Frequency',
    colPeriodKey: 'Period',
    colPerformedAt: 'Date and time',
    colResult: 'Result',
    colValues: 'Values',
    colNcCode: 'Code',
    colOrigin: 'Origin',
    colOpenedAt: 'Opened (date and time)',
    colReportedBy: 'Opened by',
    colDescription: 'Description',
    colClosedAt: 'Closed',
    colClosedBy: 'Closed by',
    colClosingNote: 'Closing note',
    colNc: 'NC',
    colAction: 'Action',
    colDueOn: 'Due',
    colVerification: 'Verification',
    colVerifiedBy: 'Verified by',
    colEvent: 'Event',
    colNote: 'Note',
    colWorker: 'Person',
    colTopic: 'Topic',
    colTrainedOn: 'Training date',
    colProvider: 'Training provider',

    // ── Value families ────────────────────────────────────────────────────────────────────
    block_homologation: 'Supplier approval',
    block_receptionControls: 'Reception checks',
    block_selfChecks: 'Self-checks',
    block_nonConformities: 'Non-conformities and corrective actions',
    block_training: 'Food handler training',

    metric_suppliers: 'Suppliers',
    metric_suppliersApproved: 'Approved',
    metric_suppliersNotApproved: 'Not approved (pending, not approved or suspended)',
    metric_homologationEvents: 'Status changes in the period',
    metric_documents: 'Documents',
    metric_documentsExpired: 'Expired documents',
    metric_lines: 'Lines received',
    metric_linesControlled: 'With a check recorded',
    metric_linesNotControlled: 'Without a check recorded',
    metric_linesTemperatureOut: 'Temperature out of range',
    metric_linesRejected: 'Rejected',
    metric_records: 'Self-checks done',
    metric_recordsFailed: 'With a KO result',
    metric_missed: 'Self-checks not done',
    metric_nonConformities: 'Non-conformities opened in the period',
    metric_nonConformitiesOpen: 'Still open or in progress',
    metric_nonConformitiesClosed: 'Closed',
    metric_actions: 'Corrective actions',
    metric_actionsOpen: 'Actions not closed',
    metric_workers: 'Food handlers',
    metric_workersValid: 'With valid training',
    metric_workersExpiring: 'With training expiring soon',
    metric_workersExpired: 'With expired training',
    metric_workersMissing: 'Without training',

    homologationStatus_pending: 'Pending',
    homologationStatus_approved: 'Approved',
    homologationStatus_not_approved: 'Not approved',
    homologationStatus_suspended: 'Suspended',

    documentType_sanitary_registry: 'Sanitary registry',
    documentType_certificate: 'Certificate',

    checkResult_ok: 'OK',
    checkResult_ko: 'KO',

    qcDecision_accepted: 'Accepted',
    qcDecision_accepted_with_incident: 'Accepted with incident',
    qcDecision_rejected: 'Rejected',

    outcome_not_controlled: 'No check recorded',
    outcome_accepted: 'Accepted',
    outcome_accepted_with_incident: 'Accepted with incident',
    outcome_rejected: 'Rejected',
    outcome_undecided: 'Decision pending',

    temperatureStatus_not_measured: 'Not measured',
    temperatureStatus_no_range: 'No reference range',
    temperatureStatus_ok: 'Within range',
    temperatureStatus_out_of_range: 'Out of range',

    kind_cleaning: 'Cleaning and disinfection',
    kind_temperature: 'Temperatures',
    kind_pests: 'Pest control',
    kind_custom: 'Other',

    frequency_daily: 'Daily',
    frequency_weekly: 'Weekly',
    frequency_monthly: 'Monthly',

    ncOrigin_reception: 'Reception',
    ncOrigin_self_check: 'Self-check',
    ncOrigin_production: 'Production',
    ncOrigin_manual: 'Manual',
    ncOrigin_other: 'Other',

    ncStatus_open: 'Open',
    ncStatus_in_progress: 'In progress',
    ncStatus_closed: 'Closed',

    actionStatus_open: 'Open',
    actionStatus_in_progress: 'In progress',
    actionStatus_closed: 'Closed',

    ncEvent_created: 'Created',
    ncEvent_status_changed: 'Status change',
    ncEvent_action_added: 'Action added',
    ncEvent_action_updated: 'Action updated',
    ncEvent_closed: 'Closed',
    ncEvent_reopened: 'Reopened',

    trainingStatus_valid: 'Valid',
    trainingStatus_expiring: 'Expiring soon',
    trainingStatus_expired: 'Expired',
    trainingStatus_missing: 'No training',

    trainingTopic_food_handler: 'Food handler',
    trainingTopic_allergens: 'Allergens',
    trainingTopic_other: 'Other',

    // Summary of the detail of an automatic NC (the same reasons as `ncDetailSummary`)
    ncSummary_reasonTemperatureRange:
      'Temperature {{temperature}} ºC, outside the range {{min}} to {{max}} ºC',
    ncSummary_reasonTemperatureAbove:
      'Temperature {{temperature}} ºC, above the maximum ({{max}} ºC)',
    ncSummary_reasonTemperatureBelow:
      'Temperature {{temperature}} ºC, below the minimum ({{min}} ºC)',
    ncSummary_reasonTemperature: 'Temperature {{temperature}} ºC out of range',
    ncSummary_reasonTemperatureUnknown: 'Temperature out of range',
    ncSummary_reasonPackagingKo: 'Packaging not conforming',
    ncSummary_reasonLabelingKo: 'Labelling not conforming',
    ncSummary_reasonDecisionRejected: 'Line rejected at the reception check',
    ncSummary_reasonDecisionAcceptedWithIncident: 'Line accepted with incident',
    ncSummary_reasonSelfCheckFailed: 'Self-check with a KO result',
    ncSummary_reasonUnknown: 'Reason: {{code}}',
    ncSummary_selfCheckFailedRange: '{{label}}: {{value}} (range {{min}} to {{max}})',
    ncSummary_selfCheckFailedBelowMin: '{{label}}: {{value}} (minimum {{min}})',
    ncSummary_selfCheckFailedAboveMax: '{{label}}: {{value}} (maximum {{max}})',
    ncSummary_selfCheckFailedValue: '{{label}}: {{value}}',
    ncSummary_selfCheckFailedKo: '{{label}}: KO',
    ncSummary_selfCheckFailedUnnamed: 'Self-check field that failed',
  },
} as const;
